import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ItemDossier\RenderItemDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/RenderItemDossierController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}/render'
*/
const RenderItemDossierController = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: RenderItemDossierController.url(args, options),
    method: 'get',
})

RenderItemDossierController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/item-dossier/{itemDossier}/render',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\RenderItemDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/RenderItemDossierController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}/render'
*/
RenderItemDossierController.url = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            itemDossier: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        itemDossier: typeof args.itemDossier === 'object'
        ? args.itemDossier.id
        : args.itemDossier,
    }

    return RenderItemDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{itemDossier}', parsedArgs.itemDossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\RenderItemDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/RenderItemDossierController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}/render'
*/
RenderItemDossierController.get = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: RenderItemDossierController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\RenderItemDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/RenderItemDossierController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}/render'
*/
RenderItemDossierController.head = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: RenderItemDossierController.url(args, options),
    method: 'head',
})

export default RenderItemDossierController